export default __webpack_public_path__ + "static/media/loader.0ba3f5f8.gif";